module.exports = __webpack_public_path__ + "static/img/name.8bd4f35.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/wxsjglm/name.png
// module id = vDpW
// module chunks = 7